// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191234/js/" + chunkId + "." + {"44":"8ce7ea39","225":"836a1dbb","481":"ea722d97","486":"ae21a35b","770":"42c5334a"}[chunkId] + ".0.2299918921676669.chunk.js";
};